import React from 'react';
import { Sparkles, Stars, Heart } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-indigo-100 flex items-center justify-center overflow-hidden">
      {/* Background animated shapes */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating shapes */}
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className={`absolute animate-float-${i % 3}`}
            style={{
              left: `${20 + (i * 15)}%`,
              top: `${10 + (i * 12)}%`,
              animationDelay: `${i * 0.5}s`,
            }}
          >
            {i % 3 === 0 && <Stars className="w-6 h-6 text-purple-300 opacity-60" />}
            {i % 3 === 1 && <Sparkles className="w-5 h-5 text-pink-300 opacity-50" />}
            {i % 3 === 2 && <Heart className="w-4 h-4 text-indigo-300 opacity-40" />}
          </div>
        ))}
      </div>

      {/* Main loading content */}
      <div className="relative z-10 text-center">
        {/* Logo/Title with magical effect */}
        <div className="mb-8">
          <h1 className="text-6xl font-bold bg-gradient-to-r from-purple-600 via-pink-500 to-indigo-600 bg-clip-text text-transparent mb-2 animate-shimmer">
            123zzz
          </h1>
          <p className="text-gray-600 text-lg animate-fade-in-up">
            ✨ Loading your magical stories...
          </p>
        </div>

        {/* Animated loading circles */}
        <div className="flex justify-center items-center space-x-2 mb-8">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className={`w-4 h-4 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 animate-bounce`}
              style={{
                animationDelay: `${i * 0.2}s`,
                animationDuration: '1s'
              }}
            ></div>
          ))}
        </div>

        {/* Magic wand animated */}
        <div className="relative">
          <div className="animate-spin-slow">
            <Sparkles className="w-12 h-12 text-purple-500 mx-auto" />
          </div>
          {/* Sparkle effects around the wand */}
          <div className="absolute -top-2 -right-2 animate-ping">
            <div className="w-2 h-2 bg-pink-400 rounded-full"></div>
          </div>
          <div className="absolute -bottom-1 -left-2 animate-ping" style={{ animationDelay: '0.5s' }}>
            <div className="w-1.5 h-1.5 bg-purple-400 rounded-full"></div>
          </div>
          <div className="absolute top-1 -left-3 animate-ping" style={{ animationDelay: '1s' }}>
            <div className="w-1 h-1 bg-indigo-400 rounded-full"></div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="mt-8 w-64 mx-auto">
          <div className="w-full bg-white/50 rounded-full h-2 overflow-hidden shadow-inner">
            <div className="h-full bg-gradient-to-r from-purple-500 via-pink-500 to-indigo-500 rounded-full animate-progress-fill"></div>
          </div>
        </div>
      </div>

      {/* Additional CSS animations */}
      <style jsx>{`
        @keyframes float-0 {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
        @keyframes float-1 {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(-180deg); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-25px) rotate(90deg); }
        }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes progress-fill {
          0% { width: 0%; }
          100% { width: 100%; }
        }
        
        .animate-float-0 { animation: float-0 3s ease-in-out infinite; }
        .animate-float-1 { animation: float-1 4s ease-in-out infinite; }
        .animate-float-2 { animation: float-2 3.5s ease-in-out infinite; }
        .animate-shimmer { 
          background-size: 200% auto;
          animation: shimmer 2s linear infinite;
        }
        .animate-fade-in-up { animation: fade-in-up 1s ease-out; }
        .animate-spin-slow { animation: spin-slow 3s linear infinite; }
        .animate-progress-fill { animation: progress-fill 2s ease-in-out infinite; }
      `}</style>
    </div>
  );
};

export default LoadingScreen;